import { createAsyncThunk } from "@reduxjs/toolkit";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { api } from "./config/axiosConfig";

const DEV_BASE_URL = process.env.REACT_APP_BASE_URL_LEGAL_CASE;

export const getLegalReport = createAsyncThunk(
    "/legal-case-analyser/report",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/legal-case-analyser/report", data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const retryLegalReport = createAsyncThunk(
    "/legal-case-analyser/retry",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/legal-case-analyser/retry", data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const  deleteLegalReport = createAsyncThunk(
    "/legal-case-analyser/delete",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/legal-case-analyser/delete", data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const uloadLegalReport = createAsyncThunk(
    "/legal-case-analyser/upload",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/legal-case-analyser/upload", data,{
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const analyseLegalReport = createAsyncThunk(
    "/legal-case-analyser/analyse",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/legal-case-analyser/analyse", data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const submitLegalFeedback = createAsyncThunk(
    "/legal-case-analyser/feedback",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/legal-case-analyser/feedback", data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const precedence = createAsyncThunk(
    "/legal-case-analyser/precedence",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/legal-case-analyser/precedence", data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);




